var _rect, _path, _path2, _mask, _path3, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlog(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 20.9048V3.09524H17V5.2381C17 5.79038 17.4477 6.2381 18 6.2381C18.5523 6.2381 19 5.79038 19 5.2381V2.04762C19 1.46904 18.5523 1 18 1H2C1.44772 1 1 1.46904 1 2.04762V21.9524C1 22.531 1.44772 23 2 23H18C18.5523 23 19 22.531 19 21.9524V16.6667C19 16.1144 18.5523 15.6667 18 15.6667C17.4477 15.6667 17 16.1144 17 16.6667V20.9048H3Z",
    fill: "#1E1E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 15.1924L14.5429 14.4852L21.2604 7.76773C21.4557 7.57247 21.7723 7.57247 21.9675 7.76773C22.1628 7.96299 22.1628 8.27958 21.9675 8.47484L15.25 15.1924Z",
    stroke: "#1E1E1E",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_1503_5196",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4438 17.5408C12.2875 17.5929 12.1387 17.4441 12.1908 17.2878L13.125 14.4853L15.2463 16.6066L12.4438 17.5408Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 14.4853L14.5392 13.0711L12.251 10.7828L11.2276 13.8528L13.125 14.4853ZM15.2463 16.6066L15.8788 18.504L18.9488 17.4806L16.6605 15.1924L15.2463 16.6066ZM12.1908 17.2878L14.0882 17.9202L12.1908 17.2878ZM14.0882 17.9202L15.0224 15.1177L11.2276 13.8528L10.2935 16.6553L14.0882 17.9202ZM11.7108 15.8995L13.8321 18.0208L16.6605 15.1924L14.5392 13.0711L11.7108 15.8995ZM14.6139 14.7092L11.8114 15.6434L13.0763 19.4381L15.8788 18.504L14.6139 14.7092ZM10.2935 16.6553C9.72017 18.3752 11.3564 20.0114 13.0763 19.4381L11.8114 15.6434C13.2185 15.1743 14.5573 16.5131 14.0882 17.9202L10.2935 16.6553Z",
    fill: "#1E1E1E",
    mask: "url(#path-3-inside-1_1503_5196)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.9062,
    y: 10.9497,
    width: 3,
    height: 2,
    transform: "rotate(-135 20.9062 10.9497)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 6,
    width: 11,
    height: 2,
    rx: 1,
    fill: "#1E1E1E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 10,
    width: 8,
    height: 2,
    rx: 1,
    fill: "#1E1E1E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/blog.35f2082ddcd02643925882135157ebba.svg";
export { ForwardRef as ReactComponent };